<h3 mat-dialog-title style="margin-bottom: 5px !important;">Emin misiniz?</h3>
<div mat-dialog-content>


    <textarea style="height: 150px;resize: none;width: 300px;margin-bottom: 10px;
              font-size: 11px;border: 1px solid #9c9c9c;padding: 4px;border-radius: 3px;"
              matInput id="description" aria-describedby="description" placeholder="Açıklama">
    </textarea>
</div>
<div mat-dialog-actions="">
    <div style="display: flex;justify-content: left;padding-top: 10px;padding-bottom: 10px;">
        <button mat-raised-button style="background-color: #359165;margin-right: 10px;color: white" (click)="rejectAbsence(data)">Evet</button>
        <button mat-raised-button style="background-color: #f23637;color: white;" [mat-dialog-close]="data" cdkFocusInitial>Hayır</button>
    </div>
</div>

